import React from 'react';
import { Routes, Route } from 'react-router-dom';

// pages
import Language from './Language';
import RaceEthnicity from './RaceEthnicity';
import Miscellaneous from './Miscellaneous';

function Other() {
  return (
    <Routes>
      <Route path="language" element={<Language />} />
      <Route path="race-ethnicity" element={<RaceEthnicity />} />
      <Route path="miscellaneous" element={<Miscellaneous />} />
    </Routes>
  );
}

export default Other;
